/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { APP_BASE_HREF } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HttpClientModule } from '@angular/common/http';
import { CoreModule } from './@core/core.module';
import { HttpModule } from '@angular/http';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { ThemeModule } from './@theme/theme.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import{ DetalleEDCComponent } from './pages/componentes/detalle-edc/detalle-edc.component';
import { NbEmailPassAuthProvider, NbAuthModule } from '@nebular/auth';

import { ModalTarjetasComponent } from '../app/pages/componentes/modal-tarjetas/modal-tarjetas.component';
import { ModalReservacionesComponent } from '../app/pages/componentes/modal-reservaciones/modal-reservaciones.component';
import { ModalReservacionStaffComponent } from '../app/pages/componentes/modal-reservacion-staff/modal-reservacion-staff.component';
import { ModalAutosComponent } from '../app/pages/componentes/modal-autos/modal-autos.component';
import { ModalAutosRegistroComponent } from '../app/pages/componentes/modal-autos-registro/modal-autos-registro.component';
import { PagesComponent } from './pages/pages.component';


import { ToasterModule } from 'angular2-toaster';
import { GrdFilterPipe } from './grd-filter.pipe';


@NgModule({
  declarations: [
    AppComponent,
    ModalTarjetasComponent,
    ModalReservacionesComponent, 
    ModalReservacionStaffComponent,
    ModalAutosComponent,
    ModalAutosRegistroComponent,
    GrdFilterPipe],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    AppRoutingModule,
    HttpModule,
    ToasterModule,
    NgbModule.forRoot(),
    ThemeModule.forRoot(),
    CoreModule.forRoot(),
    NbAuthModule.forRoot({
      providers : {
        email : {
          service : NbEmailPassAuthProvider
        }
      }
    })
  ],
  bootstrap: [AppComponent],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/', },
    DetalleEDCComponent,
    AppComponent,
    PagesComponent
  ],
  entryComponents: [
    ModalTarjetasComponent,
    ModalReservacionesComponent,
    ModalReservacionStaffComponent,
    ModalAutosComponent,
    ModalAutosRegistroComponent
  ]
})
export class AppModule {
}
